export default "__VITE_ASSET__C$PvRvuD__"